import React from "react";

import { IBuildingProfileCard } from "../../../services/zeos-api/contracts/Favorability";

interface IProps {
  profile: IBuildingProfileCard;
  onEdit: () => void;
}

export const BuildingProfileCard = ({ profile, onEdit }: IProps) => {
  const typeLabel = [profile.propertyTypeLabel, profile.buildingTypeLabel]
    .filter(Boolean)
    .join(" · ");

  return (
    <div className="bg-white rounded-xl shadow-[0_1px_4px_rgba(0,0,0,0.05)] px-8 py-8 mb-[26px]">
      <div className="flex justify-between items-start gap-4 flex-wrap">
        <div>
          <h2 className="text-[21px] font-bold text-[#2b2b2b] mb-1.5">
            Building Profile
          </h2>
          <p className="text-sm text-[#6b6b6b]">
            Here's what we've gathered about your property
          </p>
        </div>
        <button
          type="button"
          onClick={onEdit}
          className="text-[13.5px] font-semibold text-[#F5841F] hover:underline"
        >
          ✎ Edit answers
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-7 gap-y-[12px] mt-3 mb-4">
        <Fact label="Property" value={profile.addressLine} />
        <Fact label="Type" value={typeLabel || "—"} />
        <Fact label="Size" value={profile.sizeLabel} />
        <Fact label="Vintage" value={profile.vintageLabel} />
        <Fact label="Heating" value={profile.heatingLabel} />
        <Fact label="Cooling" value={profile.coolingLabel} />
        <Fact label="Utility Territory" value={profile.utilityTerritory} />
        <Fact label="Stated Goals" value={profile.statedGoalsLabel} />
      </div>

      <div className="flex gap-2.5 flex-wrap">
        {profile.isLl97Covered && (
          <span className="text-[12.5px] font-bold px-3 py-1.5 rounded-full bg-[#E9F5EE] text-[#2E8B57]">
            ✓ LL97 Covered Building
          </span>
        )}
        {profile.conEdDrEligible && (
          <span className="text-[12.5px] font-bold px-3 py-1.5 rounded-full bg-[#EEF1F8] text-[#3E4E9E]">
            ConEd Demand Response Eligible
          </span>
        )}
        {profile.isSolarReady && (
          <span className="text-[12.5px] font-bold px-3 py-1.5 rounded-full bg-[#FDF1E4] text-[#B05E0B]">
            ☀ Solar-Ready Roof
          </span>
        )}
      </div>
    </div>
  );
};

const Fact = ({ label, value }: { label: string; value: string }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.06em] text-[#6b6b6b] mb-[3px]">
      {label}
    </div>
    <div className="text-[15px] font-bold">{value}</div>
  </div>
);
